import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "13",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#D84C4C",
      "fill-rule": "evenodd",
      d: "M8.424 2.22H.972a.356.356 0 0 0-.356.356v.356H8.78v-.356a.356.356 0 0 0-.356-.357M.972 1.603A.97.97 0 0 0 0 2.576v.972h9.396v-.972a.97.97 0 0 0-.972-.972z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#D84C4C",
      "fill-rule": "evenodd",
      d: "M2.481.956c0-.528.428-.956.956-.956h2.592c.528 0 .956.428.956.956v.648h-.616V.956a.34.34 0 0 0-.34-.34H3.437a.34.34 0 0 0-.34.34v.648H2.48zM2.977 5.184c.17 0 .307.138.307.308v4.536a.308.308 0 1 1-.615 0V5.492c0-.17.138-.308.308-.308M4.814 5.184c.17 0 .308.138.308.308v4.536a.308.308 0 1 1-.615 0V5.492c0-.17.137-.308.307-.308M6.657 5.184c.17 0 .308.138.308.308v4.536a.308.308 0 1 1-.616 0V5.492c0-.17.138-.308.308-.308",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#D84C4C",
      "fill-rule": "evenodd",
      d: "M1.34 3.285v7.44c0 .55.448.994.997.989l4.8-.04a.99.99 0 0 0 .98-.988V3.285h.615v7.401c0 .881-.71 1.597-1.59 1.604l-4.8.04a1.604 1.604 0 0 1-1.617-1.604V3.285z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }